import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext, useState } from 'react';
import { LocaleContext } from '@zurich/common/contexts';
import { useTranslation } from '@zurich/common/hooks';
import { getInsuranceSegmentKeyPrefix } from '@zurich/common/utils';
import { useIsDesktop } from '@zurich/ui/hooks';
import { Button, Dialog, SummarySection } from '@zurich/ui/legacy/components';
import { getPolicySegmentsClickableRows } from './policySegmentsClickableUtils';
export function PolicySegmentClickable({ segment }) {
    const locale = useContext(LocaleContext);
    const [dialogOpen, setDialogOpen] = useState(false);
    const { t } = useTranslation();
    const isDesktop = useIsDesktop();
    const segmenyKeyPrefix = getInsuranceSegmentKeyPrefix(segment?.segmentKey);
    if (!segmenyKeyPrefix)
        return null;
    return (_jsxs(_Fragment, { children: [_jsx(Button, { size: isDesktop ? 'medium' : 'small', onClick: () => setDialogOpen(true), children: segmenyKeyPrefix }), _jsx(Dialog, { open: dialogOpen, onClose: () => setDialogOpen(false), showCloseIcon: true, dialogTitle: segmenyKeyPrefix, dialogActions: _jsx(Button, { onClick: () => setDialogOpen(false), children: t('common:button_label.close') }), children: _jsx(SummarySection, { rows: getPolicySegmentsClickableRows(segment, t, locale), editable: false, columns: 2, expandable: false }) })] }));
}
